<template>
  <v-layout row align-center justify-space-around>
    <v-flex xs12 order-lg2 id="storiesListings">
      <v-flex xs12>
        <v-btn style="position: absolute; left: 5px" outline fab dark small class="elevation-1" color="accent lighten-2" @click="goToPage('first')" :disabled="page === 1">
          <v-icon>first_page</v-icon>
        </v-btn>
        <v-btn outline fab dark small class="elevation-1" color="accent lighten-2" @click="goToPage('previous')" :disabled="page === 1">
          <v-icon>keyboard_arrow_left</v-icon>
        </v-btn>
        <v-btn class="elevation-1 noHover" style="cursor: auto" outline fab dark small color="accent lighten-2">
          <span style="color: #727272">{{ page }}</span>
        </v-btn>
        <v-btn class="elevation-1" outline fab dark small color="accent lighten-2" @click="goToPage('next')" :disabled="lastPage">
          <v-icon>keyboard_arrow_right</v-icon>
        </v-btn>
      </v-flex>
      <v-flex style="min-height: 125px" v-if="dataState === 'loading' || dataState === 'ready'" :class="dataState !== 'ready' ? 'blurClass' : ''">
        <v-data-iterator :items="stories" :rows-per-page-items="[12]" hide-actions content-tag="v-layout" row wrap>
          <v-flex slot="item" slot-scope="props" xs12 sm6 md4 lg3>
            <v-card>
              <v-layout row style="align-items: center !important;">
                <v-card-title @click="story = props.item; dialog = true" class="pointer"><h3>{{ props.item.title.substring(0, 35) + '...' }}</h3></v-card-title>
                <v-spacer></v-spacer>
                <v-tooltip top>
                  <v-avatar size="35" slot="activator" @click.stop="selectedStory = props.item.id; deleteStoryConfirmationDialog = true">
                    <v-icon class="btnHoverClass" size="20" style="border-radius: 100%">fas fa-trash</v-icon>
                  </v-avatar>
                  <span>Delete story</span>
                </v-tooltip>
              </v-layout>
              <v-divider></v-divider>
              <v-list dense>
                <v-list-tile>
                  <v-list-tile-content>Total Articles:</v-list-tile-content>
                  <v-list-tile-content class="align-end"><h4>{{ props.item.articleCount }}</h4></v-list-tile-content>
                </v-list-tile>
                <v-list-tile>
                  <v-list-tile-content>Total Tweets:</v-list-tile-content>
                  <v-list-tile-content class="align-end"><h4>{{ props.item.tweetCount }}</h4></v-list-tile-content>
                </v-list-tile>
                <v-list-tile>
                  <v-list-tile-content>Date Created:</v-list-tile-content>
                  <v-list-tile-content class="align-end">{{ formatDateTimeWithYear(new Date(props.item.dateCreated)) }}</v-list-tile-content>
                </v-list-tile>
              </v-list>
              
              <v-container grid-list-sm fluid @click="story = props.item; dialog = true" class="pointer">
                <v-layout row wrap>
                  <v-flex v-for="n in [0,1,2,3,4,5]" :key="n" xs4 d-flex>
                    <v-card flat tile class="d-flex">
                      <v-avatar color="white" tile size="100" class="mr-2">
                        <v-img v-if="props.item.articles[n] && props.item.articles[n].imageUrl" 
                          :src="props.item.articles[n].imageUrl" 
                          :lazy-src="props.item.articles[n].imageUrl"
                          aspect-ratio="1" class="grey lighten-2">
                          <v-layout slot="placeholder" fill-height align-center justify-center ma-0>
                            <v-progress-circular indeterminate color="grey lighten-5"></v-progress-circular>
                          </v-layout>
                        </v-img>
                      </v-avatar>
                    </v-card>
                  </v-flex>
                </v-layout>
              </v-container>

            </v-card>
          </v-flex>
        </v-data-iterator>
      </v-flex>
      <template v-if="dataState === 'loading'">
        <center class="alternateState">
          <v-progress-circular
            :size="70"
            :width="7"
            color="primary"
            indeterminate
          ></v-progress-circular>
        </center>
      </template>
      <template v-else-if="dataState === 'noData'">
        <div class="d-flex" style="flex-direction: column; align-items: center"><v-icon class="primary--text" style="font-size: 40px !important;width:100%">warning</v-icon><p class="accent--text mb-0 ml-2 subheading font-weight-bold">no data found</p></div>
      </template>
      <template v-else-if="dataState === 'error'">
        <div class="d-flex" style="flex-direction: column; align-items: center"><v-icon class="error--text" style="font-size: 40px !important">warning</v-icon><p class="accent--text mb-0 ml-2 subheading font-weight-bold">error connecting to server</p></div>
      </template>
      <v-flex xs12>
        <v-btn style="position: absolute; left: 5px;" outline fab dark small class="elevation-1" color="accent lighten-2" @click="goToPage('first')" :disabled="page === 1">
          <v-icon>first_page</v-icon>
        </v-btn>
        <v-btn outline fab dark small class="elevation-1" color="accent lighten-2" @click="goToPage('previous')" :disabled="page === 1">
          <v-icon>keyboard_arrow_left</v-icon>
        </v-btn>
        <v-btn class="elevation-1 noHover" style="cursor: auto" outline fab dark small color="accent lighten-2">
          <span style="color: #727272">{{ page }}</span>
        </v-btn>
        <v-btn class="elevation-1" outline fab dark small color="accent lighten-2" @click="goToPage('next')" :disabled="lastPage">
          <v-icon>keyboard_arrow_right</v-icon>
        </v-btn>
      </v-flex>
    </v-flex>

    <v-dialog v-model="dialog" fullscreen hide-overlay transition="dialog-bottom-transition">
      <v-card>
        <v-toolbar dark>
          <v-btn icon dark @click.native="dialog = false">
            <v-icon>close</v-icon>
          </v-btn>
          <v-toolbar-title>Story Details</v-toolbar-title>
          <v-spacer></v-spacer>
        </v-toolbar>
        
        <v-expansion-panel popout v-if="story && story != null" two-lines>
          <v-expansion-panel-content v-for="article in story.articles" :key="article.id">
            <v-layout slot="header" align-center row spacer>
              <v-flex xs1 sm1 md1>
                <v-avatar v-if="article.imageUrl" color="grey" tile size="40" class="mr-2">
                  <v-img :src="article.imageUrl" :lazy-src="article.imageUrl" aspect-ratio="1" class="grey lighten-2">
                    <v-layout slot="placeholder" fill-height align-center justify-center ma-0>
                      <v-progress-circular indeterminate color="grey lighten-5"></v-progress-circular>
                    </v-layout>
                  </v-img>
                  <v-icon v-if="!article.imageUrl" dark>block</v-icon>
                </v-avatar>
              </v-flex>
              
              <v-flex xs2 sm2 md2><strong>{{article.domain}}</strong></v-flex>
              <v-flex no-wrap xs8 sm8 md8><strong>{{article.title}}</strong></v-flex>
              <v-flex xs2 sm2 md2 class="grey--text" ellipsis>{{formatDateTimeWithYear(new Date(article.datePublished)) }}</v-flex>
              <v-flex>
                <v-tooltip top>
                  <v-avatar size="35" slot="activator" @click.stop="selectedArticle = article.id; deleteArticleConfirmationDialog = true">
                    <v-icon class="btnHoverClass" size="20" style="border-radius: 100%">fas fa-trash</v-icon>
                  </v-avatar>
                  <span>Delete article from story</span>
                </v-tooltip>
              </v-flex>
            </v-layout>
            
            <v-card>
              <v-divider></v-divider>
              <v-card-text v-html="article.body"></v-card-text>
              <v-card-text><small>{{article.url}}</small></v-card-text>
              <v-card-actions>
                <v-btn @click="goToArticle(article.url)" flat>Go to Article</v-btn>
                <v-btn @click="goToSource(article.domain)" flat>Go to Source</v-btn>
              </v-card-actions>
            </v-card>
          </v-expansion-panel-content>
        </v-expansion-panel>
      </v-card>
    </v-dialog>
    <v-dialog
      v-model="deleteStoryConfirmationDialog"
      width="300"
    >
      <v-card class="secondary">
        <v-card-title class="headline">Delete story?</v-card-title>
        <v-card-text>
          <v-btn @click="deleteStory" :loading="deleteLoading">Confirm</v-btn>
          <v-btn @click="deleteStoryConfirmationDialog = false; selectedStory = null" :disabled="deleteLoading">Cancel</v-btn>
        </v-card-text>
      </v-card>
    </v-dialog>
    <v-dialog
      v-model="deleteArticleConfirmationDialog"
      width="300"
    >
      <v-card class="secondary">
        <v-card-title class="headline">Delete article from story?</v-card-title>
        <v-card-text>
          <v-btn @click="deleteArticle" :loading="deleteArticleLoading">Confirm</v-btn>
          <v-btn @click="deleteArticleConfirmationDialog = false; selectedArticle = null" :disabled="deleteArticleLoading">Cancel</v-btn>
        </v-card-text>
      </v-card>
    </v-dialog>
  </v-layout>
</template>

<style scoped>
  .alternateState{
    position: absolute;
    top: 0;
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
  }
  .blurClass{
    filter: blur(5px);
    -webkit-filter: blur(5px);
  }
  .pointer{ cursor: pointer; }
  .stories{ width: 400px; }
  .noHover:hover{background-color: white !important}
  .noHover:hover:before{background-color: transparent !important}
</style>

<script>
import axios from 'axios'
import underscore from 'underscore'
import { mapGetters, mapMutations } from 'vuex'
import numeral from 'numeral'
import { formatDateTimeWithYear } from '@/helpers/formatters'

export default {
  props: {
    filters: {
      type: Object,
      default: () => ({})
    },
    options: {
      type: Object,
      default: () => ({})
    }
  },
  data () {
    return {
      dialog: false,
      dataState: 'loading',
      stories: [],
      story: null,
      page: 1,
      lastPage: false,
      deleteStoryConfirmationDialog: false,
      selectedStory: null,
      deleteLoading: false,
      deleteArticleConfirmationDialog: false,
      selectedArticle: null,
      deleteArticleLoading: false
    }
  },
  computed: {
    ...mapGetters('auth', ['isLoggedIn']),
    ...mapGetters('filters', ['getQuery', 'getFilters'])
  },
  methods: {
    ...mapMutations('notification', ['notify']),
    formatDateTimeWithYear: formatDateTimeWithYear,
    formatNumber: function (value) {
      return Number(value) > 999 ? numeral(Number(value)).format('0.0a').toUpperCase() : value
    },
    goToSource: function (source) {
      window.open('http://' + source, '_blank')
    },
    goToArticle: function (url) {
      window.open(url, '_blank')
    },
    goToPage (direction) {
      var newPage = this.page
      if (direction === 'first') {
        newPage = 1
      } else if (direction === 'previous') {
        newPage--
      } else if (direction === 'next') {
        newPage++
      }
      if (newPage !== this.page) {
        this.page = newPage
        this.getData()
      }
    },
    deleteStory () {
      this.deleteLoading = true
      axios.all([
        this.$store.dispatch('deleteStoryById', {id: this.selectedStory, query: '?projectUuid=' + this.getFilters.projectUuid})
      ]).then(axios.spread((response) => {
        if (response.data.status === 'SUCCESS') {
          this.selectedStory = null
          this.deleteStoryConfirmationDialog = false
        } else {
          this.notify({message: 'Something went wrong while fetching data.', show: true})
        }
        this.getData()
        this.deleteLoading = false
      })).catch((err) => {
        this.deleteLoading = false
        this.notify({message: 'Something went wrong while connecting to the server.', show: true})
        console.log(err)
      })
    },
    deleteArticle () {
      this.deleteArticleLoading = true
      axios.all([
        this.$store.dispatch('deleteStoryArticle', {storyId: this.story.id, articleId: this.selectedArticle, query: '?projectUuid=' + this.getFilters.projectUuid})
      ]).then(axios.spread((response) => {
        if (response.data.status === 'SUCCESS') {
          this.selectedArticle = null
          this.deleteArticleConfirmationDialog = false
        } else {
          this.notify({message: 'Something went wrong while fetching data.', show: true})
        }
        this.getData()
        this.deleteArticleLoading = false
      })).catch((err) => {
        this.deleteArticleLoading = false
        this.notify({message: 'Something went wrong while connecting to the server.', show: true})
        console.log(err)
      })
    },
    getData: function () {
      this.dataState = 'loading'
      axios.all([
        this.$store.dispatch('getStoriesWithLimitedArticles', this.getQuery({sortBy: this.options.sortBy, order: this.options.orderBy, pageSize: 12, pageNumber: this.page}))
      ]).then(axios.spread((r1) => {
        if (r1.data.status === 'SUCCESS') {
          this.stories = r1.data.payload
          if (r1.data.payload.length > 0) {
            this.dataState = 'ready'
            this.lastPage = (r1.data.payload.length < 12)
            if (this.dialog) {
              var story = this.stories.find(item => { return item.id === this.story.id })
              if (story) {
                this.story = JSON.parse(JSON.stringify(story))
              } else {
                this.dialog = false
              }
            }
          } else {
            this.dataState = 'noData'
            this.lastPage = true
          }
        } else {
          this.dataState = 'error'
          this.lastPage = true
          this.notify({message: 'Something went wrong while fetching data.', show: true})
        }
      })).catch((err) => {
        this.lastPage = true
        this.dataState = 'error'
        this.notify({message: 'Something went wrong while connecting to the server.', show: true})
        console.log(err)
      })
    }
  },
  watch: {
    filters: {
      deep: true,
      immediate: true,
      handler (newVal, oldVal) {
        if (oldVal && newVal && !underscore.isEqual(newVal, oldVal) && this.filters.dirty === false) {
          this.page = 1
          this.getData()
        }
      }
    },
    options: {
      deep: true,
      immediate: true,
      handler (newVal, oldVal) {
        if (oldVal && newVal && !underscore.isEqual(newVal, oldVal) && this.filters.dirty === false) {
          this.page = 1
          this.getData()
        }
      }
    }
  },
  mounted: function () {
    this.getData()
  }
}
</script>


// WEBPACK FOOTER //
// src/components/listings/StoriesListing.vue